import { render, staticRenderFns } from "./BookingSubtypeList.vue?vue&type=template&id=51fb61a6&"
import script from "./BookingSubtypeList.vue?vue&type=script&lang=js&"
export * from "./BookingSubtypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports